export const ecommerceGallery = [
  {
    src: "assets/product/GalleryEcommerce2.jpg",
    alt: "Detalle de producto"
  },

  {
    src: "assets/product/GalleryEcommerce4.jpg",
    alt: "Producto en uso"
  },

  {
    src: "assets/product/GalleryEcommerce10.jpg",
    alt: "Producto en detalle"
  },
  {
    src: "assets/product/GalleryEcommerce3.jpg",
    alt: "vista frontal"
  },
  {
    src: "assets/product/GalleryEcommerce6.jpg",
    alt: "Uso del producto"
  },
  {
    src: "assets/product/GalleryEcommerce9.jpg",
    alt: "Detalle de cerca"
  },

  {
    src: "assets/product/GalleryEcommerce5.jpg",
    alt: "Espacio decorativo"
  },
  {
    src: "assets/product/GalleryEcommerce1.jpg",
    alt: "Primer plano"
  },
  {
    src: "assets/product/GalleryEcommerce8.jpg",
    alt: "Fotografía ambientada"
  },

  {
    src: "assets/product/GalleryEcommerce7.jpg",
    alt: "Variedad productos"
  }
];
